import { ButtonGroup, List, Badge as MuiBadge } from '@material-ui/core';
import { Search } from '@material-ui/icons';
import styled, { css } from 'styled-components';
import { Button as DesignSystemButton } from '../Button';

export const Button = styled(DesignSystemButton)<{ selected?: boolean }>`
  ${({ selected = false, theme }) => css`
    color: ${theme.splitcPalette.neutral[1]};
    background-color: ${selected ? theme.splitcPalette.neutral[8] : theme.splitcPalette.neutral[10]};

    &:hover {
      background-color: ${theme.splitcPalette.neutral[9]};
    }
  `}
`;

export const SplitButtonContainer = styled(ButtonGroup)`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 200px;
  margin: 0;
`;

export const SplitButton = styled.button`
  ${({ theme, disabled }) => css`
    border: none;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    cursor: pointer;
    width: 10rem;
    color: ${theme.palette.text.primary};
    border-radius: 4px 0 0 4px;
    padding: 0.9em 0.8em;
    background-color: ${disabled ? 'gray' : theme.palette.primary.main};
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  `}
`;

export const SplitButtonIcon = styled.div<{ disabled?: boolean }>`
  ${({ theme, disabled }) => css`
    display: flex;
    color: ${disabled ? theme.splitcPalette.neutral[5] : theme.palette.primary.contrastText};
    font-size: 1.2rem;
  `}
`;

export const SplitButtonTitle = styled.span<{ disabled?: boolean }>`
  ${({ theme, disabled }) => css`
    font-size: 1rem;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: ${disabled ? theme.splitcPalette.neutral[5] : theme.palette.primary.contrastText};
  `}
`;

export const SplitDropdownButton = styled.button`
  ${({ theme, disabled }) => css`
    border: none;
    background-color: ${disabled ? 'gray' : theme.palette.primary.main};
    border-radius: 0 4px 4px 0;
    color: ${theme.palette.text.primary};
    cursor: pointer;
    padding: 0.6em 0.8em;
    color: ${theme.palette.primary.contrastText};
    font-size: 0.875rem;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);

    &:hover {
      background-color: ${theme.palette.primary.dark};
    }
  `}
`;

export const SplitPopoverContainer = styled.div`
  display: flex;
  flex-direction: column;

  & .MuiTypography-root {
    font-size: 0.875rem;
  }

  .MuiListItem-gutters {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .no-options-msg {
    padding: 0.75rem;
    text-align: center;
  }

  .search-input {
    padding: 0.5rem 0.5rem 0 0.5rem;
  }
`;

export const Badge = styled(MuiBadge)`
  ${({ theme }) => css`
    & .MuiBadge-badge {
      border: 1px solid
        ${
          theme.palette.type === 'dark'
            ? theme.palette.common.black
            : theme.palette.background.default
        };
    }
  `}
`;

export const SplitButtonList = styled(List)`
  padding-top: 4px;

  .internal-list {
    max-height: 18.75rem;
    overflow: auto;
  }

  .list-item {
    display: flex;
    justify-content: space-between;

    &--collapsed {
      padding-left: 1.75rem;
      gap: 0.75rem;
    }

    & .MuiTypography-root.MuiListItemText-primary {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }
`;

export const SearchIcon = styled(Search)`
  margin-right: 0.5rem;
  color: ${({ theme }) => theme.splitcPalette.neutral[6]};
`;
